import type { FormControl, FormGroup } from '@angular/forms';

import type { GridsterItem } from 'angular-gridster2';
import type { ECharts } from 'echarts/core';

import type { AsFormControlMap } from '@core/common-legacy';
// eslint-disable-next-line boundaries/element-types
import type { Theme } from '@core/theme-util'; // --FIXME
import { VisibilityLevel } from '@core/visibility-types';

import { ReportDateFilter } from './common.types';
import { ReportParamFilters } from './report-component.types';

export const NO_LIMIT_DATA = -1;
export const DEFAULT_DATA_LIMIT = NO_LIMIT_DATA;

export const DASHBOARD_BASE_PATH = 'boards/:dashboardId';

export const REPORTS_DEFAULT_VISIBILITY = {
  adminIds: [],
  level: VisibilityLevel.Private,
  roleIds: [],
};

export type ChartFactory = (
  el: HTMLDivElement | HTMLCanvasElement,
  theme: Theme,
  devicePixelRatio: number,
  locale: string,
  isExport?: boolean,
) => ECharts;

export enum DataInterval {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
}

export enum VisualizationContext {
  Preview = 'preview',
  Library = 'library',
  Builder = 'builder',
  TemplatesLibrary = 'templates-library',
  Export = 'export',
}

export const SortedIntervals = [
  DataInterval.Daily,
  DataInterval.Weekly,
  DataInterval.Monthly,
  DataInterval.Quarterly,
];

export interface DashboardComponentGridsterItem extends GridsterItem {
  localId: string | null;
  refComponentId?: number;
}

export interface GlobalFilterFormValue {
  dateFilter: ReportDateFilter;
  queryFilter: string;
}

export type GlobalFilterForm = FormGroup<{
  dateFilter: FormGroup<AsFormControlMap<GlobalFilterFormValue['dateFilter']>>;
  queryFilter: FormControl<GlobalFilterFormValue['queryFilter']>;
}>;

export const ReturnToLibraryToken = 'ReturnToLibraryToken';
export const ReturnToStartFromScratchToken = 'ReturnToStartFromScratchToken';

export type ReportDashboardsAbilities = {
  canManageReportDashboards: boolean;
  canViewReportDashboards: boolean;
  canExportData: boolean;
  canViewHiredCandidates: boolean;
  canManageRequisitions: boolean;
  canCreateCustomDashboards: boolean;
};

export interface ReportDashboardFilters {
  filters: ReportParamFilters;
  dateFilter: ReportDateFilter;
}
